import { Recommendation } from '../types';

/**
 * Pattern to match recommendations in LLM responses
 * Format: [RECOMMENDATION: title="...", href="/...", description="..."]
 */
const RECOMMENDATION_PATTERN =
  /\[RECOMMENDATION:\s*title="([^"]+)"(?:,\s*href="([^"]+)")?(?:,\s*description="([^"]+)")?\]/g;

/**
 * Parse recommendations from LLM response text
 */
export const parseRecommendations = (text: string): Recommendation[] => {
  const recommendations: Recommendation[] = [];
  const matches = text.matchAll(RECOMMENDATION_PATTERN);

  for (const match of matches) {
    const [, title, href, description] = match;

    recommendations.push({
      type: href ? 'navigation' : 'info',
      title,
      href: href || undefined,
      description: description || undefined,
    });
  }

  return recommendations;
};

/**
 * Remove recommendation markers from text for clean display
 */
export const cleanRecommendationMarkers = (text: string): string => {
  return text.replace(RECOMMENDATION_PATTERN, '').trim();
};
